import React from 'react';
// components
import { MapPopup } from '@ems/client-design-system';
// functions
import { displayCoordinate, displayAmsl } from 'src/utils/unitsOfMeasurement';
// style
import './styles.scss';

export const LocationPopup = ({
  longitude,
  latitude,
  address,
  elevation,
  altitudeUnits,
  onClose,
  languageData,
}: any) => {
  if (!latitude || !longitude || !address) {
    return null;
  }

  const { lat, lng, amsl } = languageData;

  return (
    <MapPopup
      className="location-popup"
      anchor="bottom-left"
      offsetLeft={20}
      offsetTop={-40}
      longitude={longitude}
      latitude={latitude}
      closeButton={false}
      closeOnClick={true}
      onClose={onClose}>
      <div className="location-popup">
        {address && <h3 className="location-popup_title">{address}</h3>}
        <div className="location-popup_row">
          <p className="location-popup_col">
            <span className="location-popup_label">{lat}</span>
            <span className="location-popup_value">{displayCoordinate(latitude)}</span>
          </p>
          <p className="location-popup_col">
            <span className="location-popup_label">{lng}</span>
            <span className="location-popup_value">{displayCoordinate(longitude)}</span>
          </p>
          <p className="location-popup_col">
            <span className="location-popup_label">{amsl}</span>
            <span className="location-popup_value">
              {elevation !== null ? displayAmsl(elevation, altitudeUnits) : `—`}
            </span>
          </p>
        </div>
      </div>
    </MapPopup>
  );
};
